import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, forkJoin, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { IMockExam, ICoursePlanMockExam, IPracticeTest } from 'src/app/Models/ExamAgencies';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-add-edit-weekly-practice-test-modal',
  templateUrl: './add-edit-weekly-practice-test-modal.component.html',
  styleUrls: ['./add-edit-weekly-practice-test-modal.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AddEditWeeklyPracticeTestModalComponent implements OnInit {
 @Input() WeeklyPracticeTest: IPracticeTest;
  addEditForm: FormGroup;
  statuses: IGetCodes[] = [];
  courses: IGetCodes[] = [];
  selectedCourses: string[] = [];
  courseId: number;
  availableCourseType: any[] = [];
  CourseAppliableCourseType: ICoursePlanMockExam[];
  private destroy$ = new Subject<void>();
  minDate!: string;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private examService: ExamManagementService,
    public contentservice: ContentManagementService,
    public session: SessionService,
    private readonly toaster: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
     const today = new Date();
  this.minDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
    this.addEditForm = this.fb.group({
      weeklyPracticeTestId: [{ value: '', disabled: true }],
    practiceTestSeqNumber: [{ value: '', disabled: true }],
      testName: [null, Validators.required],
      practiceTestName: [null],
      availableDate: [null, Validators.required],
      status: ['', Validators.required],
      testType: ['', Validators.required],
      applicableCourses: [[]],
      totalScore: [0],
      noOfQuestion: [0],
    });
if (this.WeeklyPracticeTest) {
  const availableDate = this.WeeklyPracticeTest.Available_Date
    ? this.WeeklyPracticeTest.Available_Date.split('T')[0]
    : null;

  this.addEditForm.patchValue({
    weeklyPracticeTestId: this.WeeklyPracticeTest.Course_Test_Id,
    practiceTestSeqNumber: this.WeeklyPracticeTest.Practice_Test_Sequence_Number,
    testName: this.WeeklyPracticeTest.Practice_Test_Name,
    status: this.WeeklyPracticeTest.Practice_Test_Status_Type_Code,
    totalScore: this.WeeklyPracticeTest.Total_Score,
    noOfQuestion: this.WeeklyPracticeTest.Number_Of_Questions,
    availableDate: availableDate,
    testType: this.WeeklyPracticeTest.Test_Type_Code || 'WeeklyTest',
  });
}

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.courseId = +params['c_id'];

      });

    const appliableCoursePlan = {};
    forkJoin({
      statuses: this.examService.getMockExamsStatusTypes().pipe(
        catchError((error) => {
          console.error('Error fetching statuses:', error);
          return of([]);
        })
      ),
      courses: this.contentservice
        .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
        .pipe(
          catchError((error) => {
            console.error('Error fetching courses:', error);
            return of([]);
          })
        ),
      availableCourseType: this.contentservice
        .getCoursePlan$(
          this.session.getUser(),
          this.courseId,
          '',
          'ASSIGNMOCKEXAM',
          '',
          ''
        )
        .pipe(
          catchError((error) => {
            return of({ coursePlan: [] });
          })
        ),
      applicableCoursePlan: this.examService
        .getWeeklyPracticeTestApplicableCoursePlan({
          ScreenName: null,
          CourseTestID: this.WeeklyPracticeTest ? this.WeeklyPracticeTest.Course_Test_Id : null,
          CourseID: this.WeeklyPracticeTest ? this.courseId : 0,
          CoursePlanID: null,
          SelectedInd: null,
        })
        .pipe(
          catchError((error) => {
            console.error('Error fetching applicable course type:', error);
            return of([]); // ✅ Return an empty array instead of null
          })
        ),
    }).subscribe(
      ({
        statuses,
        courses,
        availableCourseType,
        applicableCoursePlan, // ✅ Ensure this key matches the `forkJoin` observable key
      }: {
        statuses: any;
        courses: any;
        availableCourseType: any;
        applicableCoursePlan: ICoursePlanMockExam[]; // ✅ Corrected key name
      }) => {
        this.statuses = [...statuses];
        this.courses = courses;
        this.availableCourseType = availableCourseType.coursePlan;
        this.selectedCourses =
          applicableCoursePlan
            .filter((e) => e.Deleted_Ind === 'N')
            .map((e) => e.Course_Plan_Type_Code) ?? [];
        this.CourseAppliableCourseType = applicableCoursePlan ?? []; // ✅ Ensure it's an array
      }
    );

  }




  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',' || event.key === 'e') {
      event.preventDefault();
    }
  }
  onCourseChange(event: any) {
    if (event.target.checked) {
      this.selectedCourses.push(event.target.value);
    } else {
      this.selectedCourses = this.selectedCourses.filter(
        (c) => c !== event.target.value
      );
    }
    this.addEditForm.patchValue({ applicableCourses: this.selectedCourses });
  }
  disablecheckboxes(type: string) {
    return !this.availableCourseType.some(
      (ele) => ele.Course_Plan_Type_Code === type
    );
  }
  selectedcheckboxes(type: string) {
    return this.selectedCourses.some((ele) => ele === type);
  }
  checkedCoursePlan(type: string): boolean {
    return this.CourseAppliableCourseType.some(
      (e) => e.Course_Plan_Type_Code === type && e.Deleted_Ind === 'N'
    );
  }
  onSubmit() {
    if (this.addEditForm.valid) {
      const availableDate = this.formatAvailableDate(
        this.addEditForm.get('availableDate')?.value
      );
      const payload = {
        LoggedInUser: this.session.getUser(),
        CourseId: this.courseId,
        StudentId: null,
        TestTypeCode:this.addEditForm.get('testType')?.value ,
        ExamSeriesTypeCode: 'Series 1',
        CourseTestId: this.WeeklyPracticeTest ? this.WeeklyPracticeTest.Course_Test_Id : null,
        TestName: this.addEditForm.get('testName')?.value,
        TestSequenceNumber: this.WeeklyPracticeTest
          ? this.WeeklyPracticeTest.Practice_Test_Sequence_Number
          : null,
        TotalScore: +this.addEditForm.get('totalScore')?.value,
        NumberOfQuestions: +this.addEditForm.get('noOfQuestion')?.value,
        AvailableDate: availableDate,
        CourseTestStatusTypeCode: this.addEditForm.get('status')?.value,
        TestQuestionDifficultyLevelTypeCode: 'Mixed',
        UDTMockExamApplicableCoursePlan: this.availableCourseType.map(
          (e: any) => {
            return {
              CoursePlanID: +e.Course_Plan_Id,
              SelectedInd: this.selectedcheckboxes(e.Course_Plan_Type_Code)
                ? 'Y'
                : 'N',
            };
          }
        ),
      };

      this.examService.addEditWeeklyPracticeTest(payload).subscribe(
        (res: any) => {

          this.toaster.success('Practice Test Created', '', {
            timeOut: ConstantVars.ToastSucessTimeout,
          });
          this.activeModal.close(this.WeeklyPracticeTest ? this.WeeklyPracticeTest.Course_Test_Id: res?.NewCourseTestId);
        },
        (error: any) => {
          this.toaster.error('Something went wrong', '', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
        }
      );
    } else {
      this.addEditForm.markAllAsTouched();
    }
  }

  private formatAvailableDate(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year} 12:00:00 AM`;
  }

  setSelectedExamId(id: number | null) {
    this.examService.setSelectedExamId(id);
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
    currentUrl.includes('Exam/MockExams') ||
      currentUrl.includes('Exam/MockExamsQuestion') ||
      currentUrl.includes('Exam/AddEditMockExamsQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null); // Clear the selection
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
